var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"sm":"6","md":"4"}},[_c('b-card',{attrs:{"header":"What are widgets?"}},[_vm._v("\n        There is simple explanation what "),_c('a',{attrs:{"href":_vm.docsUrl + `/docs#platform-widgets`,"target":"_blank"}},[_vm._v("widgets")]),_vm._v(" are.\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }